import { IGetAllCategoriaAssistenciaUseCase } from "../../../presentation/useCases/read/get_all_categoria_assistencia_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";
import { CategoriaAssistenciaLista } from "../../models/categoria_assistencia_lista";

/**
 * GetAllCategoriaAssistenciaUseCase
 */

export class GetAllCategoriaAssistenciaUseCase
  extends BasePaginatedUseCase<CategoriaAssistenciaLista>
  implements IGetAllCategoriaAssistenciaUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) {
    super();
  }

  async getAllCategoriaAssistencia(
    field: number | null,
    value: string | null,
    status: number | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    var result = await this.repository.getAllCategoriaAssistencia(
      field,
      value,
      status,
      page,
      rowsPerPage,
    );

    this._items = result.items;
    this._totalItems = result.totalItems;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;
  }
}
